/* eslint-disable */

import React from "react";
import { Link } from "react-router-dom";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      {/* Home Link for navigating to the login page */}
      <Link to="/login" className="home-link">
        Home
      </Link>

      <div className="privacy-policy-content">
        <h1 className="privacy-policy-header">Privacy Policy</h1>
        <p>
          At ImagiXAI, we value your privacy and are committed to protecting your
          personal information. This Privacy Policy outlines how we collect, use,
          store, and protect your data when you use our AI-powered connected care
          platform tailored for radiology departments and hospitals.
        </p>

        <h2>1. Information We Collect</h2>
        <p>We may collect the following types of information:</p>
        <ul>
          <li>
            <strong>Personal Information:</strong> Names, email addresses, phone
            numbers, and job roles of users (Doctors, Radiologists, and Admin and
            Technician teams). Login credentials and account details for
            authentication purposes.
          </li>
          <li>
            <strong>Medical Data:</strong> Medical images, reports, and associated
            patient information uploaded for analysis or collaboration. AI-generated
            triage data and 3D models for medical purposes.
          </li>
          <li>
            <strong>Usage Data:</strong> Log data including IP addresses, browser
            type, and access times for performance and security monitoring.
          </li>
          <li>
            <strong>Cookies:</strong> We may use cookies to enhance user experience and
            improve platform functionality.
          </li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use your information for the following purposes:</p>
        <ul>
          <li>
            Facilitating real-time collaboration between doctors, radiologists, and care teams.
          </li>
          <li>
            Processing and analyzing medical images using AI tools.
          </li>
          <li>
            Ensuring HIPAA compliance and maintaining the security of medical data.
          </li>
          <li>
            Improving our platform’s functionality and user experience.
          </li>
          <li>
            Responding to user inquiries and providing customer support.
          </li>
        </ul>

        <h2>3. Data Sharing and Disclosure</h2>
        <p>We do not sell or share your personal information with third parties except:</p>
        <ul>
          <li>
            To authorized personnel within your organization (e.g., care teams, radiologists).
          </li>
          <li>
            To comply with legal obligations or government requests.
          </li>
          <li>
            To trusted third-party service providers assisting with platform operations, under strict confidentiality agreements.
          </li>
        </ul>

        <h2>4. Data Security</h2>
        <p>
          We employ industry-standard security measures, including encryption, to
          safeguard your data. Our platform adheres to HIPAA compliance standards
          for the secure handling of medical data.
        </p>

        <h2>5. Data Retention</h2>
        <p>
          We retain data for as long as necessary to fulfill the purposes outlined in this
          policy or as required by applicable laws. Users may request deletion of their
          data by contacting us at <strong>info@easiofy.com</strong>.
        </p>

        <h2>6. User Rights</h2>
        <p>As a user, you have the right to:</p>
        <ul>
          <li>Access, update, or delete your personal information.</li>
          <li>Restrict the processing of your data.</li>
          <li>Withdraw consent for data collection, where applicable.</li>
        </ul>
        <p>
          To exercise your rights, please email us at <strong>info@easiofy.com</strong>.
        </p>

        <h2>7. HIPAA Compliance</h2>
        <p>
          ImagiXAI is committed to meeting HIPAA standards to protect the confidentiality and
          integrity of medical data. All medical images and patient data processed through our
          platform are encrypted in transit and at rest.
        </p>

        <h2>8. AI Models</h2>
        <p>
          The AI models available on the platform are only to assist the radiologists and the
          specialists. Auto-generated reports by the software cannot be used as the final report.
          Please treat this as a provisional report and correlate clinically. For any discrepancy,
          please consult a Radiologist/Physician.
        </p>

        <h2>9. Updates to This Policy</h2>
        <p>
          We may update this Privacy Policy periodically. Any changes will be posted on this page with the updated effective date.
        </p>

        <h2>10. Contact Us</h2>
        <p>
          If you have questions or concerns about this Privacy Policy, please contact us at:
        </p>
        <p>
          <strong>ImagiXAI Support</strong>
          <br />
          Email: <a href="mailto:info@easiofy.com">info@easiofy.com</a>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
